import type { ReactNode } from 'react';
import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/react-query';

/**
 * QueryClientProvider — wraps `@tanstack/react-query`'s provider with the
 * webapp's shared `queryClient` instance. Mirrors the same provider shape
 * used by PE + admin under `src/app/providers/`.
 */
export function QueryClientProvider({ children }: { children: ReactNode }) {
  return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
}

export default QueryClientProvider;
